export const portfolioLocations = [
  {
    title: 'Ohio',
    href: '/portfolio/ohio',
    eyebrow: 'Central Ohio',
    description:
      'Kitchens, bathrooms, basements, laundry rooms, flooring, painting, exteriors, and more.',
  },
  {
    title: 'Michigan',
    href: '/portfolio/michigan',
    eyebrow: 'Northern Michigan',
    description:
      'Fireplaces, stone and brick, framing, foundations, and other specialty projects.',
  },
];